// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_routes_reports_reports_module_ts":"4b2fc84a39592881","src_app_bulk-user-update_bulk-user-update_module_ts":"0c95faf1e6e4961b"}[chunkId] + ".js";
};